import type { ReactNode } from 'react';

import * as S from './style';

interface CardTitleProps {
  children: ReactNode;
  titleBackground: 'sm' | 'md' | 'lg';
}

export function CardTitle({ children, titleBackground }: CardTitleProps) {
  return (
    <>
      <S.Wrapper titleBackground={titleBackground}>
        <S.Text>{children}</S.Text>
      </S.Wrapper>
    </>
  );
}
